import { useDrop } from "react-dnd";
import { ItemType } from "../design-system/components/UserDisplay/UserDisplay.jsx";

/**
 * A custom React hook that enables a drag-and-drop functionality for dropping students into a target group.
 *
 * @function useStudentDrop
 * @param {Object} options - The options object.
 * @param {string} options.targetGroupId - The ID of the target group where the student will be dropped.
 * @param {Function} options.moveStudent - A callback function that handles moving the student to the target group.
 * @returns {Object} An object containing `isOver`, a boolean indicating if a draggable item is currently over the drop zone, and `drop`, a ref callback to connect the drop target to a DOM element.
 */
export const useStudentDrop = ({ targetGroupId, moveStudent }) => {
  const [{ isOver }, drop] = useDrop({
    accept: ItemType.USER,
    drop: (item) => {
      if (item.groupId !== targetGroupId) {
        moveStudent(item.id, targetGroupId);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return { isOver, drop };
};
